interface Props {
  completed: number;
  completedColor?: string;
  bgColor?: string;
}
const ProgressBar: React.FC<Props> = ({
  completed,
  completedColor,
  bgColor,
}) => {
  const safeCompleted = Math.min(100, Math.max(0, completed));
  return (
    <div className="h-[5px] flex flex-row w-full rounded-full overflow-hidden">
      <div
        style={{
          width: `${safeCompleted}%`,
          background: completedColor ? completedColor : '#052e16',
        }}
        className="h-[5px] rounded-l-full"
      >
        <div className="w-full h-[5px]" />
      </div>
      <div
        style={{
          width: `${100 - safeCompleted}%`,
          background: bgColor ? bgColor : 'white',
        }}
        className="h-[5px] rounded-r-full"
      />
    </div>
  );
};

export default ProgressBar;
